<template>
  <v-select
    v-model="internalValue"
    :items="categories"
    item-text="code"
    item-value="_id"
    label="Perfilación"
    v-bind="$attrs"
    clearable
  >
    <!-- Cómo se ve cada opción en el menú -->
    <template #item="{ item, on, attrs }">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-avatar rounded="0">
          <LeadCategoryIcon :code="item.code" :color="item.color" />
        </v-list-item-avatar>
        <v-list-item-content>
          <span>{{ item.description }}</span>
        </v-list-item-content>
      </v-list-item>
    </template>

    <!-- Cómo se ve el item seleccionado -->
    <template v-slot:selection="{ item }">
      <div class="ma-0 pa-0 d-flex align-center" style="gap: 0.25rem;">
        <LeadCategoryIcon :code="item.code" :color="item.color" />
        <span class="text-truncate">
          {{ item.description }}
        </span>
      </div>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "LeadSelectCategory",
  props: {
    value: null,
    categories: { type: Array, required: true }
  },
  components: {
    LeadCategoryIcon: () => import("./LeadCategoryIcon.vue")
  },
  data() {
    return { selectedCategory: null };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
